export enum ConsentScope {
  google_tag_manager = "google_tag_manager",
}

export const consentCookieDefinition = {
  name: "od_cookies_consent",
  path: "/",
  maxAge: 7 * 24 * 60 * 60,
};

export const getConsentCookieDomain = (domain: string) => {
  const segments = domain.split(".");
  return segments.length === 1 ? segments[0] : segments.slice(-2).join(".");
};

export const extractConsentScopesFromCookieValue = (
  value?: string
): Set<ConsentScope> => {
  if (!value) return new Set();
  return new Set(value.split("|") as ConsentScope[]);
};

export const getCookieValueFromConsentScopes = (
  scopes: ConsentScope[]
): string => {
  return scopes.join("|");
};

const matchingFuncs = {
  matchesName: (name: string) => {
    return (cookies: Set<string>) => {
      return cookies.has(name) ? [name] : [];
    };
  },
  startsWith: (prefix: string) => {
    return (cookies: Set<string>) => {
      return Array.from(cookies).filter((name) => name.startsWith(prefix));
    };
  },
};

interface CookieDefinition {
  getMatches: (cookies: Set<string>) => string[];
  path: string;
  consentScope: ConsentScope;
}

export const cookieDefinitions: CookieDefinition[] = (() => {
  return [
    {
      getMatches: matchingFuncs.matchesName("_gid"),
      path: "/",
      consentScope: ConsentScope.google_tag_manager,
    },
    {
      getMatches: matchingFuncs.startsWith("_ga"),
      path: "/",
      consentScope: ConsentScope.google_tag_manager,
    },
  ];
})();

interface Cookie {
  name: string;
  path: string;
}

export const getCookiesToDelete = (
  cookieNames: Set<string>,
  cookieDefinitions: CookieDefinition[],
  consentScopes: Set<ConsentScope>
) => {
  // delete all cookies matching definitions without consent
  const cookiesToDelete: Cookie[] = [];
  for (const cookieDefinition of cookieDefinitions) {
    if (consentScopes.has(cookieDefinition.consentScope)) continue;

    for (const cookieName of cookieDefinition.getMatches(cookieNames)) {
      cookiesToDelete.push({
        name: cookieName,
        path: cookieDefinition.path,
      });
    }
  }
  return cookiesToDelete;
};
